import React from 'react';
import { Box, Grid, IconButton, Stack, Typography } from '@mui/material';
import { MdOutlineModeEdit } from 'react-icons/md';
import DetailTopLeft from './DetailTopLeft';
import ReactPlayer from 'react-player';
const WebinarSummaryLeft = (props) =>
{
	const { form, handleNavi } = props;

	const getFullUrl = (key) =>
	{
		if (!key) return '';

		return `${process.env.REACT_APP_S3_BASE_URL}/${key}`;
	};

	return (
		<Grid item xs={12} lg={4}>
			<Stack direction='column' border={'1px solid var(--grayE0)'} borderRadius={'var(--pixel20)'} p='var(--pixel8)' position={'relative'}>
				<Box sx={{ width: 'var(--percent100)', height: 'var(--font140)' }} borderRadius={'13px 13px 0px 0px '}>
					<img src={getFullUrl(form?.bannerImage?.[0]?.key)} alt='' style={{ width: 'var(--percent100)', height: 'var(--percent100)', borderRadius: '13px 13px 0px 0px' }}/>
				</Box>
				<Box sx={{ position: 'absolute', top: 'var(--pixel16)', right: 'var(--pixel16)', backgroundColor: 'var(--whiteColor)', width: 'var(--pixel32)', height: 'var(--pixel32)', display: 'flex', justifyContent: 'center', borderRadius: 'var(--percent50)' }}>
					<IconButton>
						<MdOutlineModeEdit fontSize={'var(--pixel18)'} color='gray' cursor={'pointer'} onClick={() => handleNavi(2)}/>
					</IconButton>
				</Box>
				<Grid container pt='var(--pixel16)'>
					<DetailTopLeft form={form} handleNavi={handleNavi}/>
				</Grid>
			</Stack>
			<Stack direction='column' spacing={2} border={'1px solid var(--grayE0)'} borderRadius={'var(--pixel20)'} p='var(--pixel12)' mt={2}>
				<Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
					<Typography sx={{ fontWeight: '600' }}>Theming</Typography>
					<IconButton>
						<MdOutlineModeEdit color='var(--txtColorBlackL)' cursor={'pointer'} onClick={() => handleNavi(3)}/>
					</IconButton>
				</Stack>
				<Grid container>
					<Grid item xs={12} sm={6} pb='var(--pixel8)'>
						<Stack direction={'row'} pr={3}>
							<Typography sx={{ pr: 1.5, minWidth: '86px' }}>Primary</Typography>
							<Box sx={{ border: 'none', padding: '0.75rem', background: form?.webinarTheme?.primary, borderRadius: 'var(--percent50)' }}/>
						</Stack>
					</Grid>
					<Grid item xs={12} sm={6}>
						<Stack direction={'row'}>
							<Typography sx={{ pr: 1.5 }}>Secondary</Typography>
							<Box sx={{ border: 'none', padding: '0.75rem', background: form?.webinarTheme?.navBar, borderRadius: 'var(--percent50)' }}/>
						</Stack>
					</Grid>
				</Grid>
				{form?.webinarBackground?.[0]?.key && <Stack direction={'column'}>
					<Typography sx={{ fontWeight: '600' }} mb={1.5}>Background</Typography>
					<Box mt={1}>
						<img
							style={{ height: 'var(--font120)', width: 'var(--font200)', borderRadius: 'var(--pixel8)' }}
							src={getFullUrl(form?.webinarBackground?.[0]?.key)}
							alt='not found'
						/>
					</Box>
				</Stack>}
				{form?.webinarLogo?.[0]?.key && <Stack direction={'column'}>
					<Typography sx={{ fontWeight: '600' }} mb={1.5}>Logo</Typography>
					<Box mt={1}>
						<img
							style={{ height: 'var(--font120)', width: 'var(--font200)', borderRadius: 'var(--pixel8)' }}
							src={getFullUrl(form?.webinarLogo?.[0]?.key)} alt='logo not found'
						/>
					</Box>
				</Stack>}
				{form?.webinarIntroVideo?.key && <Stack direction='column' sx={{ borderRadius: 'var(--pixel8)' }}>
					<Typography sx={{ fontWeight: '600' }} mb={1.5}>Intro Video</Typography>
					<Grid container sx={{ position: 'relative', aspectRatio: 16 / 9, overflow: 'hidden', borderRadius: 'var(--pixel8)', height: '90px', width: '185px' }}>
						{/* <Grid item sx={{ width: 'var(--pixel40)', height: 'var(--pixel40)',
						 overflow: 'hidden', display: 'inline-flex', flex: 'none',
						  alignItems: 'center', justifyContent: 'center', position:
						  'absolute', top: '30%', left: '40%', zIndex: 2 }}>
							<img src='/images/icons/video.svg' alt='Video Icon' />
						</Grid> */}
						<Box sx={{ width: 'var(--percent100)', height: 'var(--percent100)', borderRadius: 'var(--pixel8)', overflow: 'hidden', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
							<ReactPlayer
								url={getFullUrl(form?.webinarIntroVideo?.key)}
								controls
								width={'var(--percent100)'}
								height={'var(--percent100)'}
								style={{ borderRadius: 'var(--pixel8)', overflow: 'hidden', display: 'block', width: 'var(--percent100)', height: 'var(--percent100)' }}
							/>
						</Box>
					</Grid>
				</Stack>}
			</Stack>
		</Grid>
	);
};

export default WebinarSummaryLeft;